import { GetGraduatesAPI, DelGradAPI } from '@/api/graduates'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    // 获取毕业生信息
    async getgrad({ commit }, item) {
      const res = await GetGraduatesAPI(item)
      return res
    },
    // 删除毕业生
    async delGrad({ commit }, id) {
      await DelGradAPI(id)
    }
  }
}
